<template>
  <div>
    <div class="c-m-b-10">
      <el-select v-model="editorOption.mode" clearable filterable>
        <el-option
          v-for="item in modes"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-button @click="fullscreen = !fullscreen" icon="el-icon-full-screen" class="c-m-l-10">
        全屏
      </el-button>
      <el-button
        @click="osg.doCopy(preset ? formData[fieldName] : formData.exts[fieldName])"
        icon="el-icon-document-copy"
        class="c-m-l-10"
      >
        复制
      </el-button>
      <el-button
        v-if="editorOption.readOnly == 'nocursor'"
        @click="editorOption.readOnly = false"
        icon="el-icon-edit"
        class="c-m-l-10"
        type="success"
        plain
      >
        编辑
      </el-button>
      <el-button
        v-else
        @click="editorOption.readOnly = 'nocursor'"
        icon="el-icon-view"
        class="c-m-l-10"
        type="primary"
        plain
      >
        恢复只读
      </el-button>
    </div>
    <codemirror
      v-if="preset"
      ref="codemirror"
      v-model="formData[fieldName]"
      :options="editorOption"
    ></codemirror>
    <codemirror
      v-else
      ref="codemirror"
      v-model="formData.exts[fieldName]"
      :options="editorOption"
    ></codemirror>
    <!-- 代码框全屏 -->
    <el-dialog
      :visible.sync="fullscreen"
      :modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      class="c-dialog-fullscreen c-dialog-codemirror"
      destroy-on-close
    >
      <div slot="title">
        <el-select v-model="editorOption.mode" clearable filterable>
          <el-option
            v-for="item in modes"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button @click="fullscreen = !fullscreen" icon="el-icon-full-screen" class="c-m-l-10">
          取消全屏
        </el-button>
        <el-button
          @click="osg.doCopy(preset ? formData[fieldName] : formData.exts[fieldName])"
          icon="el-icon-document-copy"
          class="c-m-l-10"
        >
          复制
        </el-button>
        <el-button
          v-if="editorOption.readOnly == 'nocursor'"
          @click="editorOption.readOnly = false"
          icon="el-icon-edit"
          class="c-m-l-10"
          type="success"
          plain
        >
          编辑
        </el-button>
        <el-button
          v-else
          @click="editorOption.readOnly = 'nocursor'"
          icon="el-icon-view"
          class="c-m-l-10"
          type="primary"
          plain
        >
          恢复只读
        </el-button>
        <!-- <el-button
          v-if="!editorOption.readOnly && editorOption.mode == 'application/json'"
          @click="formatCode"
          icon="el-icon-edit"
          class="c-m-l-10"
        >
          格式化
        </el-button> -->
      </div>
      <codemirror
        v-if="preset"
        ref="codemirror"
        v-model="formData[fieldName]"
        :options="editorOption"
      ></codemirror>
      <codemirror
        v-else
        ref="codemirror"
        v-model="formData.exts[fieldName]"
        :options="editorOption"
      ></codemirror>
    </el-dialog>
  </div>
</template>

<script>
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/addon/edit/closebrackets.js'; // 自动补全括号
// 语言
import 'codemirror/mode/groovy/groovy.js';
import 'codemirror/mode/clike/clike.js';
import 'codemirror/mode/javascript/javascript.js';
import 'codemirror/mode/markdown/markdown.js';
// 代码折叠
import 'codemirror/addon/fold/foldgutter.css';
import 'codemirror/addon/fold/foldcode';
import 'codemirror/addon/fold/foldgutter';
import 'codemirror/addon/fold/brace-fold';
import 'codemirror/addon/fold/comment-fold';

export default {
  components: {
    codemirror
  },
  props: {
    formData: {
      type: Object,
      default: () => ({ exts: {} })
    },
    preset: Number,
    fieldName: String
  },
  data() {
    return {
      fullscreen: false, // 全屏展示
      modes: [
        { label: 'Groovy', value: 'text/x-groovy' },
        { label: 'Java', value: 'text/x-java' },
        { label: 'JavaScript', value: 'text/javascript' },
        { label: 'JSON', value: 'application/json' },
        { label: 'Markdown', value: 'text/x-markdown' }
      ],
      editorOption: {
        tabSize: 4, // 缩进字符
        styleActiveLine: true, //
        lineNumbers: true, // 编辑器左侧显示编号
        line: true, //
        mode: 'text/x-groovy', // 语言
        theme: 'default', // 主题
        autoCloseBrackets: true, // 自动补全括号
        readOnly: 'nocursor', // 只读
        // 代码折叠
        foldGutter: true,
        lineWrapping: true,
        gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter', 'CodeMirror-lint-markers']
      }
    };
  },
  mounted() {},
  computed: {
    codemirror() {
      return this.$refs.codemirror.codemirror;
    }
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.c-dialog-codemirror {
  .c-dialog-title {
    margin-right: 0 !important;
  }
  ::v-deep .el-dialog__body {
    padding: 0 !important;
    .CodeMirror {
      height: 100%;
      min-height: calc(100vh - 53px);
      .CodeMirror-scroll {
        min-height: calc(100vh - 53px);
      }
    }
  }
}
</style>
